import type { Session } from "~/session";

import type { SettingsEntry, SettingsGuardContext } from "./settings-entries";
import { settingsEntryAllowed } from "./settings-entries";

export function buildSettingsGuardContext(session: Session, aiChatEnabled: boolean): SettingsGuardContext {
  return {
    passwordChangeableHere: session.mode !== "identity-v2",
    aiChatEnabled,
  };
}

/** Whether the router may render this settings page. Password stays reachable when hidden from nav (IdP notice). */
export function settingsRouteAllowsEntry(entry: SettingsEntry, context: SettingsGuardContext): boolean {
  if (entry.directRouteWhenNavHidden) return true;
  return settingsEntryAllowed(entry, context);
}
